export default "__VITE_ASSET__Q1tGurfa__"